import { IChannelizeBroadcast } from '@/common/interfaces/channelize.interface';
import ZApiService from './ZApiService';

export default class ChannelizeService {
  private zApiService: ZApiService;

  constructor(zApiService: ZApiService) {
    this.zApiService = zApiService;
  }

  public async getLiveBroadcasts(): Promise<IChannelizeBroadcast[]> {
    return this.zApiService.getChannelizeBroadcasts();
  }
}
